import { createSlice } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'

const initialState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createCustomSlice = createSlice({
    name: 'hub/quotations/create-custom',
    initialState: initialState,
    reducers: {
        onRequest(state, actions) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createCustomActions = createCustomSlice.actions
export default createCustomSlice.reducer
